import React from 'react';

import { useUtcFormattedDate } from '../../../../hooks/use-datetime-formats';
import { ShipDateLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const ShipDate = () => {
  const { shipDate } = useFulfillmentDisplayContext();
  const shipDateDisplay = useUtcFormattedDate(shipDate);
  return <ReadonlyField label={ShipDateLabel}>{shipDateDisplay}</ReadonlyField>;
};
